import React from 'react';

const NoRecord = (props) => {
    return (
        <div className="text-center">
            <div className="alert alert-secondary">
                <i className="far fa-folder-open i-link display-3"></i>
                <br />
                {
                    props.message ?
                        props.message
                        :
                        "No record found !"
                }
            </div>
            {props.children}
        </div>
    )
}
export default NoRecord;